export enum REPORT_TYPES {
  SCORED_ENQUIRY = "SCORED_ENQUIRY",
  TRADING_HISTORY = "TRADING_HISTORY",
  INDEPTH_TRADING_HISTORY = "INDEPTH_TRADING_HISTORY",
}
